
const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] py-20">
      <div className="w-16 h-16 border-4 border-luxury-pinkBright border-t-transparent rounded-full animate-spin"></div>
      <p className="mt-4 text-white/70">Carregando perfis...</p>
    </div>
  );
};

export default LoadingState;
